import { QuizQuestion } from './../types/QuizQuestion';

export const QuizQuestions: QuizQuestion[] = [
    {
        question: 'How often do you drink alcoholic drinks?',
        options: [
            { label: 'Never', value: { points: 0, skipTo: 8 } },
            { label: 'Monthly or less', value: { points: 1 } },
            { label: '2 - 4 times a month', value: { points: 2 } },
            { label: '2 - 3 times a week', value: { points: 3 } },
            { label: '4 or more times a week', value: { points: 4 } },
        ],
    },

    {
        question: 'How many drinks containing alcohol do you have on a typical day when you are drinking?',
        description: 'select the number of alcoholic drinks',
        options: [
            { label: '1 or 2', value: { points: 0 } },
            { label: '3 or 4', value: { points: 1 } },
            { label: '5 or 6', value: { points: 2 } },
            { label: '7, 8 or 9', value: { points: 3 } },
            { label: '10 or more', value: { points: 4 } },
        ],
    },
    {
        question: 'How often do you have six or more drinks on one occasion?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Monthly or less', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'How often during the last year have you found that you were not able to stop drinking once you had started?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Less than monthly', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'How often during the last year have you failed to do what was normally expected from you because of drinking?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Less than monthly', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Less than monthly', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'How often during the last year have you had a feeling of guilt or remorse after drinking?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Less than monthly', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'How often during the last year have you been unable to remember what happened the night before because you had been drinking?',
        options: [
            { label: 'Never', value: { points: 0 } },
            { label: 'Less than monthly', value: { points: 1 } },
            { label: 'Monthly', value: { points: 2 } },
            { label: 'Weekly', value: { points: 3 } },
            { label: 'Daily or almost daily', value: { points: 4 } },
        ],
    },
    {
        question: 'Have you or someone else been injured as a result of your drinking?',
        options: [
            { label: 'No', value: { points: 0 } },
            { label: 'Yes, but not in the last year', value: { points: 2 } },
            { label: 'Yes, during the last year', value: { points: 4 } },
        ],
    },
    {
        question: 'Has a relative, friend, doctor or another health worker been concerned about your drinking or suggested you cut down?',
        options: [
            { label: 'No', value: { points: 0 } },
            { label: 'Yes, but not in the last year', value: { points: 2 } },
            { label: 'Yes, during the last year', value: { points: 4 } },
        ],
    },
];

export const MaxQuizPoints = QuizQuestions.map((q) => q.options[q.options.length - 1]).reduce((sum, option) => sum + option.value.points, 0);
